
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  // Overriding The Global Title Strategy
  override updateTitle(routerState: RouterStateSnapshot) {
    // const title = this.buildTitle(routerState);
    // if (title !== undefined) {
    //   this.title.setTitle(`Stockholm Exergi - ${title}`);
    // }
  }
}